import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12636090"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "fw_600 mb-2 d-block" }
const _hoisted_7 = { value: "" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "alert alert-success mb-4" }
const _hoisted_11 = { class: "fw_700 mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-muted mb-3"
}
const _hoisted_13 = {
  key: 0,
  class: "card p-3 mb-3"
}
const _hoisted_14 = { class: "d-flex align-items-start mb-2" }
const _hoisted_15 = { class: "fw_600" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "fs_14 text-muted ms-2"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "mb-0 fst-italic" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fileChipIcon" }, "📎", -1))
const _hoisted_27 = { class: "docLinkName" }
const _hoisted_28 = {
  key: 2,
  class: "mt-2 ps-3 border-start"
}
const _hoisted_29 = { class: "fs_14 fw_600 d-block" }
const _hoisted_30 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_31 = {
  key: 0,
  class: "fs_14 text-muted ms-2"
}
const _hoisted_32 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_33 = { class: "mb-0 fs_14 fst-italic" }
const _hoisted_34 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_35 = ["href"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fileChipIcon" }, "📎", -1))
const _hoisted_37 = { class: "docLinkName" }
const _hoisted_38 = { class: "d-flex align-items-center justify-content-center mt-4 mb-5" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "sectionTabsContainer d-flex align-items-center mb-4 pb-2" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "fs_14 fw_600" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "fw_700 mb-2" }
const _hoisted_45 = {
  key: 0,
  class: "text-muted mb-4"
}
const _hoisted_46 = {
  key: 0,
  class: "questionBlock mb-4"
}
const _hoisted_47 = { class: "card p-3" }
const _hoisted_48 = { class: "d-flex align-items-start mb-2" }
const _hoisted_49 = { class: "fw_600" }
const _hoisted_50 = {
  key: 0,
  class: "text-danger ms-1"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "d-flex align-items-center mt-2" }
const _hoisted_53 = ["name", "value", "checked", "onChange"]
const _hoisted_54 = { class: "ms-1" }
const _hoisted_55 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_56 = { class: "fs_14 text-muted" }
const _hoisted_57 = ["checked", "onChange"]
const _hoisted_58 = { class: "ms-1" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "d-flex align-items-center mt-2" }
const _hoisted_61 = ["name", "value", "checked", "onChange"]
const _hoisted_62 = { class: "ms-1" }
const _hoisted_63 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_64 = { class: "fs_14 text-muted" }
const _hoisted_65 = ["checked", "onChange"]
const _hoisted_66 = { class: "ms-1" }
const _hoisted_67 = { key: 2 }
const _hoisted_68 = ["value", "onInput", "placeholder"]
const _hoisted_69 = { key: 3 }
const _hoisted_70 = { class: "d-flex align-items-center mb-2" }
const _hoisted_71 = ["checked", "onChange"]
const _hoisted_72 = { class: "ms-2" }
const _hoisted_73 = {
  key: 4,
  class: "attachmentField"
}
const _hoisted_74 = { class: "attachmentLabel" }
const _hoisted_75 = { class: "attachmentHint" }
const _hoisted_76 = {
  key: 0,
  class: "fileChip"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fileChipIcon" }, "📎", -1))
const _hoisted_78 = ["href"]
const _hoisted_79 = ["onClick", "title"]
const _hoisted_80 = {
  key: 1,
  class: "uploadDrop"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uploadDropIcon" }, "📎", -1))
const _hoisted_82 = ["onChange"]
const _hoisted_83 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_84 = { class: "attachmentLabel d-block mb-1" }
const _hoisted_85 = { class: "attachmentHint" }
const _hoisted_86 = ["value", "onInput"]
const _hoisted_87 = {
  key: 5,
  class: "mt-3 ps-3 border-start"
}
const _hoisted_88 = {
  key: 0,
  class: "attachmentField mt-0 mb-4"
}
const _hoisted_89 = { class: "attachmentLabel" }
const _hoisted_90 = { class: "attachmentHint" }
const _hoisted_91 = {
  key: 0,
  class: "fileChip"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fileChipIcon" }, "📎", -1))
const _hoisted_93 = ["href"]
const _hoisted_94 = ["onClick", "title"]
const _hoisted_95 = {
  key: 1,
  class: "uploadDrop"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uploadDropIcon" }, "📎", -1))
const _hoisted_97 = ["onChange"]
const _hoisted_98 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_99 = { class: "attachmentLabel d-block mb-1" }
const _hoisted_100 = { class: "attachmentHint" }
const _hoisted_101 = ["value", "onInput"]
const _hoisted_102 = { class: "fs_14 fw_600 d-block mb-1" }
const _hoisted_103 = {
  key: 0,
  class: "d-flex align-items-center mt-1"
}
const _hoisted_104 = ["name", "value", "checked", "onChange"]
const _hoisted_105 = { class: "ms-1" }
const _hoisted_106 = {
  key: 1,
  class: "d-flex align-items-center mt-1"
}
const _hoisted_107 = ["name", "value", "checked", "onChange"]
const _hoisted_108 = { class: "ms-1" }
const _hoisted_109 = { key: 2 }
const _hoisted_110 = ["value", "onInput", "placeholder"]
const _hoisted_111 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_112 = { class: "fs_14 text-muted" }
const _hoisted_113 = ["checked", "onChange"]
const _hoisted_114 = { class: "ms-1" }
const _hoisted_115 = {
  key: 4,
  class: "attachmentField"
}
const _hoisted_116 = { class: "attachmentLabel" }
const _hoisted_117 = { class: "attachmentHint" }
const _hoisted_118 = {
  key: 0,
  class: "fileChip"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fileChipIcon" }, "📎", -1))
const _hoisted_120 = ["href"]
const _hoisted_121 = ["onClick", "title"]
const _hoisted_122 = {
  key: 1,
  class: "uploadDrop"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uploadDropIcon" }, "📎", -1))
const _hoisted_124 = ["onChange"]
const _hoisted_125 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_126 = { class: "attachmentLabel d-block mb-1" }
const _hoisted_127 = { class: "attachmentHint" }
const _hoisted_128 = ["value", "onInput"]
const _hoisted_129 = { class: "d-flex align-items-center justify-content-between mt-4" }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = {
  key: 1,
  class: "mt-5 pt-4 border-top"
}
const _hoisted_132 = { class: "row mb-3" }
const _hoisted_133 = { class: "col-md-6" }
const _hoisted_134 = { class: "col-md-6" }
const _hoisted_135 = { class: "mb-3" }
const _hoisted_136 = ["checked"]
const _hoisted_137 = { class: "d-flex align-items-center justify-content-center mt-4 mb-5" }
const _hoisted_138 = ["disabled"]
const _hoisted_139 = {
  key: 2,
  class: "d-flex align-items-center justify-content-center mt-4 mb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Due Diligence Survey",
        text: "Due Diligence Survey",
        class: "mb-0"
      })
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.factorySummaries.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_localized_text, {
                  localizedKey: "You need to add at least one production site in your profile before completing the survey.",
                  text: "You need to add at least one production site in your profile before completing the survey."
                }),
                _hoisted_4,
                _createVNode(_component_router_link, {
                  to: "/provider/profile",
                  class: "fw_600 mt-2 d-inline-block"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Go to Profile",
                      text: "Go to Profile"
                    }),
                    _createTextVNode(" → ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.factorySummaries.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Select Production Site",
                      text: "Select Production Site"
                    })
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    style: {"max-width":"400px"},
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFactoryId) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFactoryChange()))
                  }, [
                    _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$localizationService.getLocalizedValue("-- Select a production site --", "-- Select a production site --")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factorySummaries, (fs) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: fs.factoryId,
                        value: fs.factoryId
                      }, _toDisplayString(fs.name) + _toDisplayString(fs.responseStatus === 1 ? ' ✓' : (fs.hasResponse ? ' (Draft)' : '')), 9, _hoisted_8))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selectedFactoryId]
                  ])
                ]),
                (_ctx.selectedFactorySubmitted && _ctx.submittedResponse)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Survey completed for this production site.",
                          text: "Survey completed for this production site."
                        })
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.template.sections, (section, si) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "mb-4",
                          key: section.sectionId
                        }, [
                          _createElementVNode("h5", _hoisted_11, _toDisplayString(si + 1) + ". " + _toDisplayString(_ctx.getLocalized(section.title)), 1),
                          (_ctx.getLocalized(section.description))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.getLocalized(section.description)), 1))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.questions, (question) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: question.questionId
                            }, [
                              (_ctx.isQuestionVisible(question, _ctx.submittedResponse.answers))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getLocalized(question.text)), 1)
                                    ]),
                                    (question.subQuestions.length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          (question.questionType === 0 || question.questionType === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["answerBadge", _ctx.getAnswerClass(_ctx.getSubmittedValue(question.questionId, ''))])
                                                }, _toDisplayString(_ctx.getSubmittedValue(question.questionId, '') || '-'), 3),
                                                (_ctx.getSubmittedEvidence(question.questionId, ''))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                                      _createVNode(_component_localized_text, {
                                                        localizedKey: "Evidence available",
                                                        text: "Evidence available"
                                                      })
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (question.questionType === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.getSubmittedInfo(question.questionId, '') || '-'), 1)
                                                ]))
                                              : (question.questionType === 3)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.certificationOptions, (cert) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: cert.certificationId
                                                      }, [
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass(["fs_14", _ctx.getSubmittedCert(question.questionId, cert.certificationId) ? 'fw_600' : 'text-muted'])
                                                        }, [
                                                          (_ctx.getSubmittedCert(question.questionId, cert.certificationId))
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "✓"))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_23, "✗")),
                                                          _createTextVNode(" " + _toDisplayString(_ctx.getLocalized(cert.name)), 1)
                                                        ], 2)
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.getSubmittedAttachment(question.questionId, ''))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                          _createElementVNode("a", {
                                            href: _ctx.getSubmittedAttachment(question.questionId, '').publicUrl,
                                            target: "_blank",
                                            class: "docLink"
                                          }, [
                                            _hoisted_26,
                                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.getSubmittedAttachment(question.questionId, '').originalFileName), 1)
                                          ], 8, _hoisted_25)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (question.subQuestions.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.subQuestions, (sub) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "mb-2",
                                              key: sub.subQuestionId
                                            }, [
                                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.getLocalized(sub.text)), 1),
                                              (sub.questionType === 0 || sub.questionType === 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass(["answerBadge", _ctx.getAnswerClass(_ctx.getSubmittedValue(question.questionId, sub.subQuestionId))])
                                                    }, _toDisplayString(_ctx.getSubmittedValue(question.questionId, sub.subQuestionId) || '-'), 3),
                                                    (_ctx.getSubmittedEvidence(question.questionId, sub.subQuestionId))
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                                          _createVNode(_component_localized_text, {
                                                            localizedKey: "Evidence available",
                                                            text: "Evidence available"
                                                          })
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : (sub.questionType === 2)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                      _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.getSubmittedInfo(question.questionId, sub.subQuestionId) || '-'), 1)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                              (_ctx.getSubmittedAttachment(question.questionId, sub.subQuestionId))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                    _createElementVNode("a", {
                                                      href: _ctx.getSubmittedAttachment(question.questionId, sub.subQuestionId).publicUrl,
                                                      target: "_blank",
                                                      class: "docLink"
                                                    }, [
                                                      _hoisted_36,
                                                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.getSubmittedAttachment(question.questionId, sub.subQuestionId).originalFileName), 1)
                                                    ], 8, _hoisted_35)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/provider')))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Back to Dashboard",
                            text: "Back to Dashboard"
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedFactoryId && !_ctx.selectedFactorySubmitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.template.sections, (section, si) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["sectionTab pointer px-3 py-2 me-2", { 'active': _ctx.currentSectionIndex === si }]),
                            key: section.sectionId,
                            onClick: ($event: any) => (_ctx.goToSection(si))
                          }, [
                            _createElementVNode("span", _hoisted_42, _toDisplayString(si + 1) + ". " + _toDisplayString(_ctx.getLocalized(section.title)), 1)
                          ], 10, _hoisted_41))
                        }), 128))
                      ]),
                      (_ctx.currentSection)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("h5", _hoisted_44, _toDisplayString(_ctx.getLocalized(_ctx.currentSection.title)), 1),
                            (_ctx.getLocalized(_ctx.currentSection.description))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.getLocalized(_ctx.currentSection.description)), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSection.questions, (question) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: question.questionId
                              }, [
                                (_ctx.isQuestionVisible(question, _ctx.answers))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("div", _hoisted_48, [
                                          _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.getLocalized(question.text)), 1),
                                          (question.isRequired)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, "*"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (question.questionType === 0 && question.subQuestions.length === 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                              _createElementVNode("div", _hoisted_52, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yesNoPartiallyOptions, (opt) => {
                                                  return (_openBlock(), _createElementBlock("label", {
                                                    class: "radioOption me-3",
                                                    key: opt.value
                                                  }, [
                                                    _createElementVNode("input", {
                                                      type: "radio",
                                                      name: 'q_' + question.questionId + '_' + _ctx.selectedFactoryId,
                                                      value: opt.value,
                                                      checked: _ctx.getAnswer(question.questionId, '').response === opt.value,
                                                      onChange: ($event: any) => (_ctx.setAnswer(question.questionId, '', opt.value))
                                                    }, null, 40, _hoisted_53),
                                                    _createElementVNode("span", _hoisted_54, _toDisplayString(opt.label), 1)
                                                  ]))
                                                }), 128))
                                              ]),
                                              (question.hasEvidenceField && _ctx.getAnswer(question.questionId, '').response)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                    _createElementVNode("label", _hoisted_56, [
                                                      _createElementVNode("input", {
                                                        type: "checkbox",
                                                        checked: _ctx.getAnswer(question.questionId, '').evidenceAvailable === true,
                                                        onChange: ($event: any) => (_ctx.toggleEvidence(question.questionId, ''))
                                                      }, null, 40, _hoisted_57),
                                                      _createElementVNode("span", _hoisted_58, [
                                                        _createVNode(_component_localized_text, {
                                                          localizedKey: "Evidence available",
                                                          text: "Evidence available"
                                                        })
                                                      ])
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (question.questionType === 1 && question.subQuestions.length === 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                _createElementVNode("div", _hoisted_60, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yesNoOptions, (opt) => {
                                                    return (_openBlock(), _createElementBlock("label", {
                                                      class: "radioOption me-3",
                                                      key: opt.value
                                                    }, [
                                                      _createElementVNode("input", {
                                                        type: "radio",
                                                        name: 'q_' + question.questionId + '_' + _ctx.selectedFactoryId,
                                                        value: opt.value,
                                                        checked: _ctx.getAnswer(question.questionId, '').response === opt.value,
                                                        onChange: ($event: any) => (_ctx.setAnswer(question.questionId, '', opt.value))
                                                      }, null, 40, _hoisted_61),
                                                      _createElementVNode("span", _hoisted_62, _toDisplayString(opt.label), 1)
                                                    ]))
                                                  }), 128))
                                                ]),
                                                (question.hasEvidenceField && _ctx.getAnswer(question.questionId, '').response)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                      _createElementVNode("label", _hoisted_64, [
                                                        _createElementVNode("input", {
                                                          type: "checkbox",
                                                          checked: _ctx.getAnswer(question.questionId, '').evidenceAvailable === true,
                                                          onChange: ($event: any) => (_ctx.toggleEvidence(question.questionId, ''))
                                                        }, null, 40, _hoisted_65),
                                                        _createElementVNode("span", _hoisted_66, [
                                                          _createVNode(_component_localized_text, {
                                                            localizedKey: "Evidence available",
                                                            text: "Evidence available"
                                                          })
                                                        ])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (question.questionType === 2 && question.subQuestions.length === 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                  _createElementVNode("textarea", {
                                                    class: "form-control mt-2",
                                                    rows: "3",
                                                    value: _ctx.getAnswer(question.questionId, '').informationalText,
                                                    onInput: ($event: any) => (_ctx.setInformationalText(question.questionId, '', $event.target.value)),
                                                    placeholder: _ctx.$localizationService.getLocalizedValue('Enter details...', 'Enter details...')
                                                  }, "\r\n                                ", 40, _hoisted_68)
                                                ]))
                                              : (question.questionType === 3)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.certificationOptions, (cert) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        class: "mt-2",
                                                        key: cert.certificationId
                                                      }, [
                                                        _createElementVNode("label", _hoisted_70, [
                                                          _createElementVNode("input", {
                                                            type: "checkbox",
                                                            checked: _ctx.isCertificationSelected(question.questionId, cert.certificationId),
                                                            onChange: ($event: any) => (_ctx.toggleCertification(question.questionId, cert.certificationId))
                                                          }, null, 40, _hoisted_71),
                                                          _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.getLocalized(cert.name)), 1)
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true),
                                        (question.allowFileUpload && question.subQuestions.length === 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                              _createElementVNode("div", _hoisted_74, [
                                                _createVNode(_component_localized_text, {
                                                  localizedKey: "Supporting document",
                                                  text: "Supporting document"
                                                }),
                                                _createElementVNode("span", _hoisted_75, [
                                                  _createTextVNode("("),
                                                  _createVNode(_component_localized_text, {
                                                    localizedKey: "optional",
                                                    text: "optional"
                                                  }),
                                                  _createTextVNode(")")
                                                ])
                                              ]),
                                              (_ctx.getAnswer(question.questionId, '').attachment)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                    _hoisted_77,
                                                    _createElementVNode("a", {
                                                      href: _ctx.getAnswer(question.questionId, '').attachment.publicUrl,
                                                      target: "_blank",
                                                      class: "fileChipName"
                                                    }, _toDisplayString(_ctx.getAnswer(question.questionId, '').attachment.originalFileName), 9, _hoisted_78),
                                                    _createElementVNode("button", {
                                                      class: "fileChipRemove",
                                                      onClick: ($event: any) => (_ctx.removeAnswerFile(question.questionId, '')),
                                                      title: _ctx.$localizationService.getLocalizedValue('Remove', 'Remove')
                                                    }, "×", 8, _hoisted_79)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("label", _hoisted_80, [
                                                    _hoisted_81,
                                                    _createVNode(_component_localized_text, {
                                                      localizedKey: "Upload file",
                                                      text: "Upload file"
                                                    }),
                                                    _createElementVNode("input", {
                                                      type: "file",
                                                      hidden: "",
                                                      onChange: ($event: any) => (_ctx.onAnswerFileSelected(question.questionId, '', $event))
                                                    }, null, 40, _hoisted_82)
                                                  ])),
                                              (question.isCertificateDocument && _ctx.getAnswer(question.questionId, '').attachment)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                                    _createElementVNode("label", _hoisted_84, [
                                                      _createVNode(_component_localized_text, {
                                                        localizedKey: "Expiration date",
                                                        text: "Expiration date"
                                                      }),
                                                      _createElementVNode("span", _hoisted_85, [
                                                        _createTextVNode("("),
                                                        _createVNode(_component_localized_text, {
                                                          localizedKey: "required",
                                                          text: "required"
                                                        }),
                                                        _createTextVNode(")")
                                                      ])
                                                    ]),
                                                    _createElementVNode("input", {
                                                      type: "date",
                                                      class: "form-control form-control-sm",
                                                      style: {"max-width":"200px"},
                                                      value: _ctx.getAnswer(question.questionId, '').attachmentExpirationDate,
                                                      onInput: ($event: any) => (_ctx.setAttachmentExpiration(question.questionId, '', ($event.target as HTMLInputElement).value))
                                                    }, null, 40, _hoisted_86)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (question.subQuestions.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                              (question.allowFileUpload)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                                    _createElementVNode("div", _hoisted_89, [
                                                      _createVNode(_component_localized_text, {
                                                        localizedKey: "Supporting document",
                                                        text: "Supporting document"
                                                      }),
                                                      _createElementVNode("span", _hoisted_90, [
                                                        _createTextVNode("("),
                                                        _createVNode(_component_localized_text, {
                                                          localizedKey: "optional",
                                                          text: "optional"
                                                        }),
                                                        _createTextVNode(")")
                                                      ])
                                                    ]),
                                                    (_ctx.getAnswer(question.questionId, '').attachment)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                          _hoisted_92,
                                                          _createElementVNode("a", {
                                                            href: _ctx.getAnswer(question.questionId, '').attachment.publicUrl,
                                                            target: "_blank",
                                                            class: "fileChipName"
                                                          }, _toDisplayString(_ctx.getAnswer(question.questionId, '').attachment.originalFileName), 9, _hoisted_93),
                                                          _createElementVNode("button", {
                                                            class: "fileChipRemove",
                                                            onClick: ($event: any) => (_ctx.removeAnswerFile(question.questionId, '')),
                                                            title: _ctx.$localizationService.getLocalizedValue('Remove', 'Remove')
                                                          }, "×", 8, _hoisted_94)
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("label", _hoisted_95, [
                                                          _hoisted_96,
                                                          _createVNode(_component_localized_text, {
                                                            localizedKey: "Upload file",
                                                            text: "Upload file"
                                                          }),
                                                          _createElementVNode("input", {
                                                            type: "file",
                                                            hidden: "",
                                                            onChange: ($event: any) => (_ctx.onAnswerFileSelected(question.questionId, '', $event))
                                                          }, null, 40, _hoisted_97)
                                                        ])),
                                                    (question.isCertificateDocument && _ctx.getAnswer(question.questionId, '').attachment)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                                          _createElementVNode("label", _hoisted_99, [
                                                            _createVNode(_component_localized_text, {
                                                              localizedKey: "Expiration date",
                                                              text: "Expiration date"
                                                            }),
                                                            _createElementVNode("span", _hoisted_100, [
                                                              _createTextVNode("("),
                                                              _createVNode(_component_localized_text, {
                                                                localizedKey: "required",
                                                                text: "required"
                                                              }),
                                                              _createTextVNode(")")
                                                            ])
                                                          ]),
                                                          _createElementVNode("input", {
                                                            type: "date",
                                                            class: "form-control form-control-sm",
                                                            style: {"max-width":"200px"},
                                                            value: _ctx.getAnswer(question.questionId, '').attachmentExpirationDate,
                                                            onInput: ($event: any) => (_ctx.setAttachmentExpiration(question.questionId, '', ($event.target as HTMLInputElement).value))
                                                          }, null, 40, _hoisted_101)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.subQuestions, (sub) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "subQuestion mb-3",
                                                  key: sub.subQuestionId
                                                }, [
                                                  _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.getLocalized(sub.text)), 1),
                                                  (sub.questionType === 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yesNoPartiallyOptions, (opt) => {
                                                          return (_openBlock(), _createElementBlock("label", {
                                                            class: "radioOption me-3",
                                                            key: opt.value
                                                          }, [
                                                            _createElementVNode("input", {
                                                              type: "radio",
                                                              name: 'q_' + question.questionId + '_' + sub.subQuestionId + '_' + _ctx.selectedFactoryId,
                                                              value: opt.value,
                                                              checked: _ctx.getAnswer(question.questionId, sub.subQuestionId).response === opt.value,
                                                              onChange: ($event: any) => (_ctx.setAnswer(question.questionId, sub.subQuestionId, opt.value))
                                                            }, null, 40, _hoisted_104),
                                                            _createElementVNode("span", _hoisted_105, _toDisplayString(opt.label), 1)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : (sub.questionType === 1)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yesNoOptions, (opt) => {
                                                            return (_openBlock(), _createElementBlock("label", {
                                                              class: "radioOption me-3",
                                                              key: opt.value
                                                            }, [
                                                              _createElementVNode("input", {
                                                                type: "radio",
                                                                name: 'q_' + question.questionId + '_' + sub.subQuestionId + '_' + _ctx.selectedFactoryId,
                                                                value: opt.value,
                                                                checked: _ctx.getAnswer(question.questionId, sub.subQuestionId).response === opt.value,
                                                                onChange: ($event: any) => (_ctx.setAnswer(question.questionId, sub.subQuestionId, opt.value))
                                                              }, null, 40, _hoisted_107),
                                                              _createElementVNode("span", _hoisted_108, _toDisplayString(opt.label), 1)
                                                            ]))
                                                          }), 128))
                                                        ]))
                                                      : (sub.questionType === 2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                                            _createElementVNode("textarea", {
                                                              class: "form-control mt-1",
                                                              rows: "2",
                                                              value: _ctx.getAnswer(question.questionId, sub.subQuestionId).informationalText,
                                                              onInput: ($event: any) => (_ctx.setInformationalText(question.questionId, sub.subQuestionId, $event.target.value)),
                                                              placeholder: _ctx.$localizationService.getLocalizedValue('Enter details...', 'Enter details...')
                                                            }, "\r\n                                        ", 40, _hoisted_110)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                  (sub.hasEvidenceField && _ctx.getAnswer(question.questionId, sub.subQuestionId).response)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                                        _createElementVNode("label", _hoisted_112, [
                                                          _createElementVNode("input", {
                                                            type: "checkbox",
                                                            checked: _ctx.getAnswer(question.questionId, sub.subQuestionId).evidenceAvailable === true,
                                                            onChange: ($event: any) => (_ctx.toggleEvidence(question.questionId, sub.subQuestionId))
                                                          }, null, 40, _hoisted_113),
                                                          _createElementVNode("span", _hoisted_114, [
                                                            _createVNode(_component_localized_text, {
                                                              localizedKey: "Evidence available",
                                                              text: "Evidence available"
                                                            })
                                                          ])
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (sub.allowFileUpload)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                                        _createElementVNode("div", _hoisted_116, [
                                                          _createVNode(_component_localized_text, {
                                                            localizedKey: "Supporting document",
                                                            text: "Supporting document"
                                                          }),
                                                          _createElementVNode("span", _hoisted_117, [
                                                            _createTextVNode("("),
                                                            _createVNode(_component_localized_text, {
                                                              localizedKey: "optional",
                                                              text: "optional"
                                                            }),
                                                            _createTextVNode(")")
                                                          ])
                                                        ]),
                                                        (_ctx.getAnswer(question.questionId, sub.subQuestionId).attachment)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                              _hoisted_119,
                                                              _createElementVNode("a", {
                                                                href: _ctx.getAnswer(question.questionId, sub.subQuestionId).attachment.publicUrl,
                                                                target: "_blank",
                                                                class: "fileChipName"
                                                              }, _toDisplayString(_ctx.getAnswer(question.questionId, sub.subQuestionId).attachment.originalFileName), 9, _hoisted_120),
                                                              _createElementVNode("button", {
                                                                class: "fileChipRemove",
                                                                onClick: ($event: any) => (_ctx.removeAnswerFile(question.questionId, sub.subQuestionId)),
                                                                title: _ctx.$localizationService.getLocalizedValue('Remove', 'Remove')
                                                              }, "×", 8, _hoisted_121)
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("label", _hoisted_122, [
                                                              _hoisted_123,
                                                              _createVNode(_component_localized_text, {
                                                                localizedKey: "Upload file",
                                                                text: "Upload file"
                                                              }),
                                                              _createElementVNode("input", {
                                                                type: "file",
                                                                hidden: "",
                                                                onChange: ($event: any) => (_ctx.onAnswerFileSelected(question.questionId, sub.subQuestionId, $event))
                                                              }, null, 40, _hoisted_124)
                                                            ])),
                                                        (sub.isCertificateDocument && _ctx.getAnswer(question.questionId, sub.subQuestionId).attachment)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                                              _createElementVNode("label", _hoisted_126, [
                                                                _createVNode(_component_localized_text, {
                                                                  localizedKey: "Expiration date",
                                                                  text: "Expiration date"
                                                                }),
                                                                _createElementVNode("span", _hoisted_127, [
                                                                  _createTextVNode("("),
                                                                  _createVNode(_component_localized_text, {
                                                                    localizedKey: "required",
                                                                    text: "required"
                                                                  }),
                                                                  _createTextVNode(")")
                                                                ])
                                                              ]),
                                                              _createElementVNode("input", {
                                                                type: "date",
                                                                class: "form-control form-control-sm",
                                                                style: {"max-width":"200px"},
                                                                value: _ctx.getAnswer(question.questionId, sub.subQuestionId).attachmentExpirationDate,
                                                                onInput: ($event: any) => (_ctx.setAttachmentExpiration(question.questionId, sub.subQuestionId, ($event.target as HTMLInputElement).value))
                                                              }, null, 40, _hoisted_128)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128)),
                            _createElementVNode("div", _hoisted_129, [
                              (_ctx.currentSectionIndex > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-secondary",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToSection(_ctx.currentSectionIndex - 1)))
                                  }, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Previous",
                                      text: "Previous"
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_130)),
                              (_ctx.currentSectionIndex < _ctx.template.sections.length - 1)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    class: "btn btn-tertiary",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToSection(_ctx.currentSectionIndex + 1)))
                                  }, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Next",
                                      text: "Next"
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.currentSectionIndex === _ctx.template.sections.length - 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                            _createVNode(_component_localized_text, {
                              type: "h5",
                              localizedKey: "Declaration",
                              text: "Declaration",
                              class: "mb-3"
                            }),
                            _createElementVNode("div", _hoisted_132, [
                              _createElementVNode("div", _hoisted_133, [
                                _createVNode(_component_form_field, {
                                  type: "text",
                                  modelValue: _ctx.submitModel.declarationName,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.submitModel.declarationName) = $event)),
                                  labelKey: "Full Name *",
                                  labelValue: "Full Name *",
                                  placeholderKey: "Full Name",
                                  placeholderValue: "Full Name",
                                  required: true
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_134, [
                                _createVNode(_component_form_field, {
                                  type: "text",
                                  modelValue: _ctx.submitModel.declarationPosition,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.submitModel.declarationPosition) = $event)),
                                  labelKey: "Position *",
                                  labelValue: "Position *",
                                  placeholderKey: "Position",
                                  placeholderValue: "Position",
                                  required: true
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_135, [
                              _createElementVNode("label", {
                                class: "d-flex align-items-start pointer",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitModel.declarationAccepted = !_ctx.submitModel.declarationAccepted))
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  class: "mt-1 me-2",
                                  checked: _ctx.submitModel.declarationAccepted
                                }, null, 8, _hoisted_136),
                                _createVNode(_component_localized_text, {
                                  localizedKey: "I declare that all information provided is accurate and complete to the best of my knowledge.",
                                  text: "I declare that all information provided is accurate and complete to the best of my knowledge."
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_137, [
                              _createElementVNode("button", {
                                class: "btn btn-secondary me-3",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveDraft()))
                              }, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Save Draft",
                                  text: "Save Draft"
                                })
                              ]),
                              _createElementVNode("button", {
                                class: "btn btn-tertiary",
                                disabled: _ctx.submitDisabled,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.confirmSubmit()))
                              }, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Submit Survey",
                                  text: "Submit Survey"
                                })
                              ], 8, _hoisted_138)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_139, [
                            _createElementVNode("button", {
                              class: "btn btn-secondary",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveDraft()))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Save Draft",
                                text: "Save Draft"
                              })
                            ])
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}